module.exports = __webpack_public_path__ + "static/media/BankWallet.c6f6c5fe.svg";